import Accordion from "@/components/Accordion";
import { tv } from "tailwind-variants";
import { Caption } from "@/components/Typography";
import { useTranslation } from "react-i18next";

const styles = tv({
  slots: {
    grid: "grid grid-cols-1 grid-rows-3 gap-10 sm:grid-cols-3 sm:grid-rows-1 sm:gap-30",
    caption: "font-semibold uppercase !leading-[25px]",
    info: "!leading-[25px]",
  },
});

const HowItWorks = () => {
  const { t } = useTranslation();
  const { grid, caption, info } = styles();

  const renderTitle = () => (
    <Caption className={caption()}>{t("email.usage.howItWorks.title")}</Caption>
  );

  const renderBody = () => (
    <div className={grid()}>
      <div>
        <Caption className={caption()}>
          {t("email.usage.howItWorks.step1.title")}
        </Caption>
        <Caption className={info()}>
          {t("email.usage.howItWorks.step1.info")}
        </Caption>
      </div>
      <div>
        <Caption className={caption()}>
          {t("email.usage.howItWorks.step2.title")}
        </Caption>
        <Caption className={info()}>
          {t("email.usage.howItWorks.step2.info")}
        </Caption>
      </div>
      <div>
        <Caption className={caption()}>
          {t("email.usage.howItWorks.step3.title")}
        </Caption>
        <Caption className={info()}>
          {t("email.usage.howItWorks.step3.info")}
        </Caption>
      </div>
    </div>
  );

  return (
    <Accordion topContent={renderTitle()} hasShadow={false} defaultIsExpanded>
      {renderBody()}
    </Accordion>
  );
};

export default HowItWorks;
